export default {
  path: 'config',
  name: 'config',
  redirect: { name: 'config.index' },
  children: [
    { path: '', name: 'config.index', component: () => import('pages/config/IndexPage.vue') },
    {
      path: 'update',
      name: 'config.update',
      component: () => import('pages/config/UpdatePage.vue'),
    },
  ],
}
